import React from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import WebFormHeader from 'components/web-form/WebFormHeader';
import Form from 'components/web-form/Form';
import { createStyles } from '../../globalStyles';

const WebFormPage = (): JSX.Element => {
  const classes = createStyles();
  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <WebFormHeader />
        <Form />
      </div>
    </ProposalStatusLayout>
  );
};

export default WebFormPage;
